import React, { useState, useEffect } from 'react'
import { useGeoFetch, useGeoState } from '../../components/GeoProvider'
import DataCards from '../../components/DataCards'

const HeaderDataStats = () => {
    const [headerData, setHeaderData] = useState()
      const { getRefreshDateFilter, getStateFilter, getAgeGroupFilter, getGenderFilter,
          getVaccineTypeFilter,setRefreshDateFilter,setStateFilter,setAgeGroupFilter,setGenderFilter, setVaccineTypeFilter } =
          useGeoState()
     const { data: headersData, error: headersDataError } = useGeoFetch(
       '',
       '',
       'memberdata',
       '', 
      {geo_parent:'US',refresh_date:getRefreshDateFilter,state:getStateFilter,gender:getGenderFilter,age_group:getAgeGroupFilter,vaccine_type:getVaccineTypeFilter},
       'POST'
     )
   
     useEffect(() => {
       if (headersData !== null && headersData !== undefined) {
         setHeaderData(headersData.response_data)
        
       }
     }, [headersData])

  return (
    <>
    {headerData !== undefined &&
    <DataCards data={headerData}/>
    }
      
    </>
)}
export default HeaderDataStats
